import { mapGetters } from 'vuex';
import { objectToGetParams } from './../../../helpers';

const Email = {
	name: 'Email',
	template: `
		<span class="social" @click="emailLink(url, subject, body)">
			<img :src="icon" />
			<span class="social__name">{{name}}</span>
		</span>
	`,
	created: function() {
		this.icon = `${process.env.IMAGE_PATH}/gunnebo_share-mail.svg`;
	},
	methods: {
		emailLink(url, subject, body ) {
			window.open(
				'mailto:' +
					objectToGetParams({
						subject,
						body: body || url
					}),
				'__blank'
			);
		}
  },
	props: {
    url: {
      type: String,
      required: true
    },
    subject: {
      required: false,
      type: String
    },
    body: {
      required: false,
      type: String
    },
		name: {
			type: String,
		}
  },
};

export default Email;



// WEBPACK FOOTER //
// ../shared/components/social/social-email/index.js